import { githubDarkInit, githubLightInit } from '@uiw/codemirror-theme-github';

// We can customize the theme here
export const darkTheme = githubDarkInit();
export const lightTheme = githubLightInit();
